import api, { formDataApi } from "api";
import getWrappedUseQuery from "api/helpers/getWrappedUseQuery";
import KEYS from "api/queries/keys";
import apiClient from "api-client";
import { FileTemplateResult } from "generated/api";

import getWrappedUseMutation from "../../helpers/getWrappedUseMutation";

export interface TimeSlotsImportErrorFile {
  errorFileContent?: string;
  errorFileName?: string;
  errorFileContentType?: string;
}

export interface TimeSlotsImportResponse {
  errorFile?: TimeSlotsImportErrorFile;
  isSuccess?: boolean;
  successItemsCount?: number;
  failedItemsCount?: number;
  fileName?: string;
  uploadedBy?: string;
  uploadedAt?: string;
}

interface TimeSlotsImportRequest {
  forumId: number;
  formFile: File;
  importMode: string;
  importKey: string;
}

const importTimeslots = ({ forumId, formFile, importMode, importKey }: TimeSlotsImportRequest, action: string) => {
  const formData = new FormData();
  formData.append("formFile", formFile);
  formData.append("importMode", importMode);
  formData.append("importKey", importKey);

  return formDataApi.post<TimeSlotsImportResponse>(`/forums/${forumId}/import/timeslots/${action}`, formData);
};

export const useImportBedroomsMutation = getWrappedUseMutation(apiClient.FileImport.venues.bedrooms.post);

export const useImportForumBedroomsMutation = getWrappedUseMutation(apiClient.FileImport.forums.bedrooms.post);

export const useImportForumFacilitiesMutation = getWrappedUseMutation(apiClient.FileImport.forums.facilities.post);

export const useImportFacilitiesMutation = getWrappedUseMutation(apiClient.FileImport.venues.facilities.post);

export const useImportTablesMutation = getWrappedUseMutation(apiClient.FileImport.venues.tables.post);

export const useImportForumTablesMutation = getWrappedUseMutation(apiClient.FileImport.forums.tables.post);

export const useImportTimeslotsMutation = getWrappedUseMutation(apiClient.FileImport.timeslots.post);

export const useCreateImportTimeslotsMutation = getWrappedUseMutation((params: TimeSlotsImportRequest) =>
  importTimeslots(params, "create"),
);

export const useValidateImportForumSeminarSessionsMutation = getWrappedUseMutation(
  apiClient.FileImport.forums.seminarSessions.validate.post,
);

export const useImportForumSeminarSessionsMutation = getWrappedUseMutation(
  apiClient.FileImport.forums.seminarSessions.create.post,
);

export const useGetImportForumSeminarSessionsTemplate = getWrappedUseQuery(
  KEYS.GET_IMPORT_FORUM_SEMINAR_SESSIONS_TEMPLATE,
  apiClient.FileImport.forums.seminarSessions.template.get,
);

export const useGetImportTimeslotsTemplate = getWrappedUseQuery(KEYS.GET_IMPORT_TIMESLOTS_TEMPLATE, () =>
  api.get<FileTemplateResult>("/timeslots/template"),
);
